import { render, staticRenderFns } from "./articleSimilaryGoods.vue?vue&type=template&id=402a320d&scoped=true&"
import script from "./articleSimilaryGoods.vue?vue&type=script&lang=js&"
export * from "./articleSimilaryGoods.vue?vue&type=script&lang=js&"
import style0 from "./articleSimilaryGoods.vue?vue&type=style&index=0&id=402a320d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402a320d",
  null
  
)

export default component.exports